import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectWarehouseDS } from "@EUForms/selectors";

const  WareHouseDetail=({saveData,updateData,renderForm})=>{
    const dispatch=useDispatch()
    const dataSource=useSelector(selectWarehouseDS)
    const onChange=useCallback(({target: {value,name}},data, otherFields={})=>dispatch(updateData({key:"warehouse",data:{[name]:value,...otherFields}})),[updateData])

    const onBlur=useCallback(({target: {value,name}},data, otherFields={})=>saveData({"warehouse":{[name]:value || " ",...otherFields}}),[saveData])

    const onSelect=useCallback((e, {value,name})=>{
            onChange({target:{value: value?.trim(),name}})
            onBlur({target:{value: value?.trim(),name}})
            ,[onChange,onBlur]
    })
    
   
  
  return(
    renderForm && renderForm({onSelect,onChange,onBlur,dataSource})
  )
}


export default React.memo(WareHouseDetail)